/**
 * Product card image carousels — slide transition + live drag swipe.
 * Desktop: prev/next arrow buttons. Mobile: swipe only (no arrows).
 * Zero dependencies. Deferred.
 */
(function () {
  'use strict';

  var SLIDE_DURATION = '380ms cubic-bezier(0.4, 0, 0.2, 1)';
  var SWIPE_THRESHOLD = 0.25; // fraction of card width to trigger slide

  function initCarousel(el) {
    var slides = Array.prototype.slice.call(el.querySelectorAll('.product-card__slide'));
    var progressFill = el.querySelector('[data-card-progress-fill]');
    var count = slides.length;
    if (count <= 1) return;

    var current = 0;
    var dragDir = null; // 'h' | 'v' | null
    var lastOffset = [];

    // Carrusel infinito: cada foto se coloca en el lado MAS CERCANO, no en su
    // posicion absoluta. Con 3 fotos y estando en la primera, la tercera se
    // aparca a la izquierda (-1) en vez de a la derecha (+2), asi que al
    // deslizar hacia atras ya esta ahi esperando.
    function offsetFor(i) {
      var off = i - current;
      if (off > count / 2) off -= count;
      if (off < -count / 2) off += count;
      return off;
    }

    function setPositions(withTransition) {
      slides.forEach(function (slide, i) {
        var off = offsetFor(i);
        // Cuando una foto cambia de extremo su salto es mayor que un paso.
        // Esa se recoloca SIN animacion: de lo contrario cruzaria la tarjeta
        // entera por delante de las demas. Es invisible porque ocurre fuera
        // de la zona visible.
        var jumped = lastOffset[i] !== undefined && Math.abs(off - lastOffset[i]) > 1;
        slide.style.transition = withTransition && !jumped ? 'transform ' + SLIDE_DURATION : 'none';
        slide.style.transform = 'translateX(' + off * 100 + '%)';
        lastOffset[i] = off;
      });
    }

    el.setAttribute('data-carousel-ready', '1');
    setPositions(false);

    // El ancho del tramo es fijo (1/count, puesto ya en el style inline de
    // Liquid) — esto solo lo desplaza, nunca lo agranda. withTransition
    // false durante el arrastre (sigue al dedo 1:1, "live"), true al
    // asentarse en una foto (goTo o soltar sin pasar el umbral).
    function setProgress(index, withTransition) {
      if (!progressFill) return;
      progressFill.style.transition = withTransition ? '' : 'none';
      var wrapped = ((index % count) + count) % count;
      progressFill.style.left = (wrapped / count) * 100 + '%';
    }

    function goTo(idx) {
      // Envolver en vez de recortar: desde la ultima foto se sigue a la
      // primera, y al reves. El doble modulo es para que un indice negativo
      // no devuelva negativo, que es lo que hace % en JavaScript.
      var next = ((idx % count) + count) % count;
      if (next === current) {
        setPositions(true);
        setProgress(current, true);
        return;
      }
      current = next;
      setProgress(current, true);
      setPositions(true);
    }

    var prevBtn = el.querySelector('[data-card-prev]');
    var nextBtn = el.querySelector('[data-card-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + 1);
      });
    }

    var touchStartX = 0;
    var touchStartY = 0;

    el.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
        dragDir = null;
        slides.forEach(function (slide) {
          slide.style.transition = 'none';
        });
      },
      { passive: true }
    );

    el.addEventListener(
      'touchmove',
      function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;

        if (!dragDir && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) {
          dragDir = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
        }

        if (dragDir !== 'h') return;

        // Reclamar el gesto: sin esto el navegador seguia haciendo SU scroll
        // vertical a la vez que nosotros moviamos las fotos, y un deslizamiento
        // en diagonal hacia las dos cosas. Antes era imposible: el listener
        // estaba registrado como passive, y un listener pasivo no puede
        // llamar a preventDefault.
        if (e.cancelable) e.preventDefault();

        var pct = (dx / el.offsetWidth) * 100;
        slides.forEach(function (slide, i) {
          // offsetFor y no (i - current): arrastrando hacia atras desde la
          // primera foto tiene que asomar la ultima, no un hueco en blanco.
          slide.style.transform = 'translateX(' + (offsetFor(i) * 100 + pct) + '%)';
        });
        // "Live": el tramo activo sigue al dedo igual que las fotos, no
        // espera a que el gesto termine para saltar de sitio. pct positivo
        // = arrastrando hacia la foto anterior, de ahi el signo negativo.
        setProgress(current - pct / 100, false);
      },
      { passive: false }
    );

    el.addEventListener(
      'touchend',
      function (e) {
        var dx = touchStartX - e.changedTouches[0].clientX;

        if (dragDir === 'h') {
          if (Math.abs(dx) > el.offsetWidth * SWIPE_THRESHOLD) {
            goTo(dx > 0 ? current + 1 : current - 1);
          } else {
            setPositions(true);
            // No se cruzo el umbral: la barra vuelve a asentarse en la foto
            // actual (con transicion), igual que las fotos vuelven a su sitio.
            setProgress(current, true);
          }
        } else {
          setPositions(false);
        }
      },
      { passive: true }
    );
  }

  function initAll() {
    document.querySelectorAll('.product-card__image[data-carousel]').forEach(function (el) {
      if (el.dataset.carouselInit) return;
      el.dataset.carouselInit = '1';
      initCarousel(el);
    });
  }

  // ── Quick-add "+" button — mini modal de tallas, añade al carrito ────────
  function initQuickAdd(card) {
    var btn = card.querySelector('[data-quick-btn]');
    var sizes = card.querySelector('[data-quick-sizes]');
    var media = card.querySelector('.product-card__media');
    if (!btn || !sizes || !media) return;

    function open() {
      sizes.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      sizes.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      sizes.classList.contains('is-open') ? close() : open();
    });

    // "Si quitas el hover se cierra" — salir del área de la imagen/modal lo cierra.
    media.addEventListener('mouseleave', close);

    sizes.querySelectorAll('[data-quick-add-size]').forEach(function (sizeBtn) {
      sizeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeBtn.classList.contains('is-oos') || sizeBtn.classList.contains('is-adding')) return;

        var variantId = sizeBtn.dataset.variantId;
        sizeBtn.classList.add('is-adding');

        fetch(themeApiRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function (item) {
            document.dispatchEvent(new CustomEvent('cart:added', { detail: item }));
            close();
          })
          .catch(function () {})
          .finally(function () {
            sizeBtn.classList.remove('is-adding');
          });
      });
    });
  }

  function initAllQuickAdd() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      if (card.dataset.quickAddInit) return;
      card.dataset.quickAddInit = '1';
      initQuickAdd(card);
    });
  }

  initAll();
  initAllQuickAdd();

  // Re-init after a future section re-render (e.g. Storefront Filtering,
  // Section Rendering API) dispatches this event on the document.
  document.addEventListener('vv:products-loaded', function () {
    initAll();
    initAllQuickAdd();
  });
})();
